<template>
    <mt-header :title="msg" fixed>
        <mt-button icon="back" @click="handleback" slot="left"></mt-button>
        <img src="@/assets/search.png" class="search-img" slot="right" v-if="isSearch" @click="search"/>
    </mt-header>
</template>

<script>

export default {
  name: 'Header',
  props: {
    msg: String,
    type: String,
    isSearch: {
      default: false,
      type:Boolean
    }
  },
  methods: {
    handleback() {
      switch (this.type) {
        case 'Order':
          this.$router.push({name:'Mine'});
          break;
        case 'Notice':
          this.$router.replace({path:`/Notice/NoticeCard?type=${sessionStorage.getItem('_pageType')}`});
          break;
        case 'myNotice':
          this.$router.replace({path:`/Notice/NewsCard?type=${sessionStorage.getItem('_pageType')}`});
          break;
        case 'Team':
          this.$router.push({name:'RecruitIndex'});
          break;
        default:
          this.$router.go(-1);
          break;
      }
    },
    search() {
      this.$store.commit('searchStr', true);
    }
  }
}
</script>

<style lang="less" scoped>
.mint-header.is-fixed {
    left: 50%;
    max-width: 640px;
    width: 100%;
    transform: translateX(-50%);
}
.mint-header{
  background: white;
  color: black;
  height: 0.44rem;
  font-size: 16px;
}
.search-img{
  width: 0.16rem;
  height: 0.16rem;
}
</style>
